import './Tile.css';

interface TileFaceProps {
  letter: string;
  value: number;
  blank: boolean;
}

/**
 * The inside of a tile: the letter and (for normal tiles) its value. The
 * `.tile` box around it is rendered by the owner (rack button, board square,
 * preview chip) so each can use its own element and motion props.
 */
export function TileFace({ letter, value, blank }: TileFaceProps) {
  return (
    <>
      <span className="tile__letter" aria-hidden="true">
        {letter}
      </span>
      {!blank && (
        <span className="tile__value" data-value={value} aria-hidden="true">
          {value}
        </span>
      )}
    </>
  );
}

/** A small static tile (wordmark, room code, chips, legends). */
export function MiniTile({
  letter,
  value,
  blank = false,
  className,
}: {
  letter: string;
  value?: number;
  blank?: boolean;
  className?: string;
}) {
  return (
    <span className={`tile tile--mini${className ? ` ${className}` : ''}`} data-blank={blank || undefined}>
      <span className="tile__letter" aria-hidden="true">
        {letter}
      </span>
      {value !== undefined && !blank && (
        <span className="tile__value" data-value={value} aria-hidden="true">
          {value}
        </span>
      )}
    </span>
  );
}
